// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"315":"8874083b","787":"d215db02"}[chunkId] + ".chunk.js";
};